import { React } from "react";
import { Navigate } from "react-router-dom";
import {hasPermission, isAuthenticated} from "../../services";
import {SIGN_IN} from "../../constants/routes";

const AuthGuard = ({children, requiredRoles = [], ...rest}) => {
  if (!isAuthenticated()) {
    return <Navigate to={SIGN_IN} replace />
  }
  if (requiredRoles.length > 0 && !hasPermission(requiredRoles)) {
    return <Navigate to="/error-403" replace />
  }
  return children;
};

export default AuthGuard;

